import $ from 'jquery';
import '../vendor/slick-carousel/slick.fix';

const defaults = {
  speed: 500,
  fade: true,
  slide: '.field-image, a',
  autoplay: true,
  autoplaySpeed: 4000,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 690,
      settings: {
        arrows: false,
      },
    },
  ],
};

/**
 * Gallery Constructor
 */
function Gallery(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = $.extend(true, defaults, options);
  this.$gallery = this.build();
  this.ready();
}

Gallery.prototype = {
  build() {
    return this.$element.slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Gallery;



// WEBPACK FOOTER //
// ./Gallery.js